import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import type { MarketingContentFieldsFragment } from 'bundles/xddp/__generated__/contentfulTypes';

import 'css!bundles/xddp/components/__styles__/about/AboutCard';

class AboutCard extends React.Component<MarketingContentFieldsFragment> {
  renderTextBox = () => {
    const { description } = this.props;

    return (
      <Grid md={6} sm={12} item>
        <Markdown className="about-description" source={description} />
      </Grid>
    );
  };

  renderMediaBox = () => {
    const { visualAlternativeText, visual } = this.props;

    return (
      <Grid md={6} sm={12} item>
        <Imgix className="about-banner" src={visual?.url ?? ''} alt={visualAlternativeText ?? ''} />
      </Grid>
    );
  };

  render() {
    const { title, description, textOnLeft } = this.props;

    if (!title || !description) {
      return null;
    }

    return (
      <div className="rc-AboutCard">
        <Grid container>
          <Grid>
            <Typography className="about-title" variant="h2">
              {title}
            </Typography>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" spacing={24}>
          {textOnLeft ? this.renderTextBox() : this.renderMediaBox()}
          {textOnLeft ? this.renderMediaBox() : this.renderTextBox()}
        </Grid>
      </div>
    );
  }
}

export default AboutCard;
